var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConferenceRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5415 41.125H25.4582",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 31.3334V41.125",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2118 13.1573C16.2168 16.5346 14.5806 22.0237 13.314 26.22C12.5486 28.7555 14.4501 31.3333 17.0986 31.3333H29.7295C32.4275 31.3333 34.3176 28.6693 33.4263 26.1228L28.8548 13.0614C28.5799 12.2759 27.8386 11.75 27.0064 11.75H19.0928C18.2229 11.75 17.4576 12.3228 17.2118 13.1573Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6877 21.5416L11.3574 17.3788C10.9964 16.9275 10.9131 16.3142 11.1408 15.783L13.4068 10.4957C13.5326 10.202 13.9382 10.1745 14.1026 10.4485L16.646 14.6875",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7292 25.4583L9.22085 21.0729C9.03601 20.8419 8.67156 20.8914 8.55501 21.1633L6.22229 26.6063C6.00666 27.1095 6.06927 27.6886 6.38743 28.1341L9.01353 31.8106C10.1163 33.3545 11.8963 34.2708 13.7937 34.2708C15.3224 34.2708 17.1556 34.2708 18.6042 34.2708V34.2708C20.0493 34.2708 21.0697 32.855 20.6127 31.4841L20.5625 31.3333",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.771 34.2709V41.125",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.604 34.2709V41.125",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3123 20.5625L34.2707 18.1145L35.5134 16.5612C35.9396 16.0284 35.972 15.2811 35.5936 14.7134L32.6194 10.2522C32.4695 10.0274 32.1423 10.0183 31.9802 10.2345L29.3748 13.7083",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2917 25.4584L37.7564 20.1007C37.9487 19.87 38.3185 19.9327 38.424 20.214L40.8319 26.6352C41.0151 27.1237 40.9431 27.6713 40.6399 28.0959L37.9865 31.8106C36.8837 33.3546 35.1031 34.2709 33.2058 34.2709H28.3958V34.2709C27.3143 34.2709 26.4375 33.3941 26.4375 32.3125V31.3334",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.229 34.2709V41.125",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M28.396 34.2709V41.125",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5835 10.7708V7.44167C19.5835 6.57642 20.2849 5.875 21.1502 5.875H24.871C25.7362 5.875 26.4377 6.57642 26.4377 7.44167V10.7708",
    stroke: "#1C1C1C",
    strokeWidth: 1.95833,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConferenceRoom);
export default __webpack_public_path__ + "static/media/conference_room.22c1bc5c8de7ffd443e058c2e13c421c.svg";
export { ForwardRef as ReactComponent };